import { captureException } from '@sortlist-frontend/mlm/standalone';
import type { TrackingPublisher } from '@sortlist-frontend/tracking/edge';

import { AB_TEST_ERROR } from '../constants';
import { EventPayload } from '../types';

/**
 * The url of the API route to call from the client side
 * Lives under that path in the Nextjs app
 */
const apiRouteSuffix = '/api/ab';

/**
 * Used to call the API url above, should be used from the client side and
 * lives within each app's API routes, hence the internal name
 */
export const postAbTestEventInternal = async (event: EventPayload) => {
  try {
    await fetch(apiRouteSuffix, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event),
      cache: 'no-store',
    });
  } catch (fetchError) {
    captureException(`${AB_TEST_ERROR}: event failed sending to ${apiRouteSuffix}`, {
      extra: { error: fetchError, event },
      tags: { fetchError: (fetchError as Error).message },
    });
  }
};

export const postAbTestEventExternal = async (event: EventPayload, publisher: TrackingPublisher) => {
  try {
    await publisher.publish('abTestEvents', event);
  } catch (error) {
    captureException(`${AB_TEST_ERROR}: event failed sending to firehose (edge)`, {
      extra: { error, event },
    });
  }
};
